// utils/rbacUtils.ts

import { PermissionType } from "constants/types/permission";

export type GroupedPermissions = Record<string, PermissionType[]>;

/**
 * Gom nhóm danh sách permissions theo thuộc tính `module`
 */
export const groupPermissionsByModule = (
  permissions: PermissionType[],
): GroupedPermissions => {
  return permissions?.reduce(
    (acc: GroupedPermissions, curr: PermissionType) => {
      const { module } = curr;
      if (!acc[module]) {
        acc[module] = [];
      }
      acc[module].push(curr);
      return acc;
    },
    {},
  );
};
